export const appMenu = [
  {
    label: 'Inicio',
    path: '/',
    icon: 'home',
  },
  {
    label: 'Conócenos',
    path: '/about',
    icon: 'info',
  },
  {
    label: 'Agenda con',
    path: '/members',
    icon: 'phone',
    open: false,
    children: [
      {
        label: 'Colabs',
        path: '/advisors/collaborator',
        icon: 'phone',
      },
      {
        label: 'Experts',
        path: '/advisors/expert',
        icon: 'phone',
      },
      {
        label: 'Asesores',
        path: '/advisors/ies',
        icon: 'phone',
      },
      // {
      //   label: 'Proveedores',
      //   path: '/suppliers',
      //   icon: 'phone'
      // }
    ],
  },
  {
    label: 'Proveedores',
    path: '/suppliers',
    icon: 'phone'
  },
  {
    label: 'Recursos',
    path: '/resources',
    icon: 'phone',
    // open: false,
    // children: [
    //   {
    //     label: 'Videos',
    //     path: '/resources/videos',
    //     icon: 'phone'
    //   },
    //   {
    //     label: 'Herramientas',
    //     path: '/resources/tools',
    //     icon: 'phone'
    //   }
    // ]
  },
  {
    label: 'Eventos',
    path: '/events',
    icon: 'phone',
  },
  {
    label: 'Noticias',
    path: '/news',
    icon: 'phone',
  },
];